<survey [model]="model"></survey>
